import { Link } from 'react-router-dom';
import { episodes } from '@/mocks/episodes';
import EpisodeCard from '@/components/feature/EpisodeCard';

export default function QuickEpisodes() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-3 mb-8">
        <div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-50">
            第一季剧集快捷入口
          </h2>
          <p className="mt-2 text-sm text-foreground-400">全部 12 集，点击任意卡片进入剧集详情与播放页面</p>
        </div>
        <Link
          to="/category"
          className="inline-flex items-center gap-1 text-sm text-accent-400 hover:text-accent-300 transition-colors whitespace-nowrap"
        >
          查看完整目录
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
        {episodes.map((episode) => (
          <EpisodeCard key={episode.id} episode={episode} />
        ))}
      </div>
    </section>
  );
}